// extracted by mini-css-extract-plugin
module.exports = {"header":"actions_header__3y4j7","heading":"actions_heading__xib3U","container":"actions_container__3tIZK"};